import PRODUCT_TYPE, { CLOSED, DELINQUENT, DORMANT, NON_SUPPORTING_PAG_CLIENTS, PRE_DELIVERY, RC, } from "../const/products";
import isPayLaterLoanType from "./isPayLaterLoanType";
import isSecuredInstallment from "./isSecuredInstallment";
import loanPaidOff from "./loanPaidOff";
var isEligibleForMAPButton = function (_a) {
    var currentBalance = _a.currentBalance, isSetpay = _a.isSetpay, isClosedWithBalance = _a.isClosedWithBalance, clientId = _a.clientId, shouldShowCreditBalanceRefund = _a.shouldShowCreditBalanceRefund, conditions = _a.conditions, product = _a.product, registered = _a.registered;
    var isDormant = conditions.includes(DORMANT);
    var isClosed = conditions.includes(CLOSED);
    var isPredelivery = conditions.includes(PRE_DELIVERY);
    var isLoanPaidOff = loanPaidOff({
        currentBalance: currentBalance,
        isPredelivery: isPredelivery,
        productType: product.type,
    });
    var isUnregisteredRetailCard = product.lineOfBusiness === RC && !registered;
    var isSecuredInstallmentLoan = isSecuredInstallment(product.type);
    var currentBalanceValue = Number(currentBalance);
    var balanceEqualLessThanZero = currentBalanceValue <= 0;
    var isSetpayLoanPaidOff = (isSetpay || isSecuredInstallmentLoan) && balanceEqualLessThanZero;
    var isClosedAndHasNegativeBalance = isClosedWithBalance && balanceEqualLessThanZero;
    var checkCurrentBalanceStatus = isPredelivery || balanceEqualLessThanZero;
    var isPAGDisabled = NON_SUPPORTING_PAG_CLIENTS.includes(clientId) && isUnregisteredRetailCard;
    var checkSecuredInstallment = isSecuredInstallmentLoan && isDormant;
    var checkConditionForRCAccounts = (isClosed || isClosedWithBalance) && checkCurrentBalanceStatus;
    return (!isLoanPaidOff &&
        !isPAGDisabled &&
        !isSetpayLoanPaidOff &&
        !isClosedAndHasNegativeBalance &&
        !shouldShowCreditBalanceRefund &&
        !checkSecuredInstallment &&
        !checkConditionForRCAccounts);
};
/**
 * New 'Digital Collections Experience' changes when Make a Payment
 * button should be displayed, enabled by a feature flag:
 * - Delinquent and in customer assistance plan
 * - Delinquent and enrolled in settlement
 * @returns boolean value
 */
var isDigitalCollectionsExperienceAndEligible = function (_a) {
    var customerAssistancePlan = _a.customerAssistancePlan, settlementEnrolled = _a.settlementEnrolled, isDelinquent = _a.isDelinquent, registered = _a.registered, isDCEEnabled = _a.isDCEEnabled;
    var isInCollections = customerAssistancePlan || settlementEnrolled || isDelinquent;
    // Pre feature flag behavior
    var isInCollectionsOrUnregistered = !isInCollections || !registered;
    var isDCE = !isDelinquent || customerAssistancePlan || !!settlementEnrolled;
    return isDCEEnabled ? isDCE : isInCollectionsOrUnregistered;
};
/**
 * Determines if the Make a Payment button should be displayed
 * More details about the Account Card display states here:
 * https://syf-agile.atlassian.net/wiki/spaces/VIS/pages/110106798/Account+Card+MFE
 * @returns boolean value to show/hide the MAP button
 */
var shouldShowPaymentButton = function (_a) {
    var _b, _c;
    var isClosedWithBalance = _a.isClosedWithBalance, accountSummaryData = _a.accountSummaryData, accountData = _a.accountData, shouldShowCreditBalanceRefund = _a.shouldShowCreditBalanceRefund, isDCEEnabled = _a.isDCEEnabled;
    if (!accountSummaryData)
        return false;
    var registered = Boolean((_c = (_b = accountData === null || accountData === void 0 ? void 0 : accountData.registration) === null || _b === void 0 ? void 0 : _b.registered) !== null && _c !== void 0 ? _c : false);
    var product = accountSummaryData.product;
    var _d = accountSummaryData.billing, customerAssistancePlan = _d.customerAssistancePlan, settlementEnrolled = _d.settlementEnrolled, _e = accountSummaryData.product.clientId, clientId = _e === void 0 ? "" : _e, currentBalance = accountSummaryData.credit.currentBalance, conditions = accountSummaryData.conditions;
    var isSetpay = product.type === PRODUCT_TYPE.INSTALLMENT_LOAN;
    var isSetpayLater = isPayLaterLoanType(product.type);
    var isDCEAndEligible = isDigitalCollectionsExperienceAndEligible({
        customerAssistancePlan: customerAssistancePlan,
        settlementEnrolled: Boolean(settlementEnrolled),
        isDelinquent: conditions.includes(DELINQUENT),
        registered: registered,
        isDCEEnabled: Boolean(isDCEEnabled),
    });
    var isEligibleForPayment = isEligibleForMAPButton({
        conditions: conditions,
        product: product,
        clientId: clientId,
        registered: registered,
        currentBalance: currentBalance,
        isSetpay: isSetpay,
        isClosedWithBalance: isClosedWithBalance,
        shouldShowCreditBalanceRefund: shouldShowCreditBalanceRefund,
    });
    return ((isSetpay || isSetpayLater || isDCEAndEligible) && isEligibleForPayment);
};
export default shouldShowPaymentButton;
//# sourceMappingURL=shouldShowPaymentButton.js.map